const mainCommonFR = require("./common.fr.json");
const apiTokensFR = require("./api-tokens.fr.json");
const FMAccounts = require('./fm-accounts.fr.json');

export const commonFR = {
  ...mainCommonFR,
  "api-tokens": apiTokensFR,
  "fm-accounts": FMAccounts
}
